import olkinLogo from './assets/images/olkin_logo.png';

export const MOCK_PRICE_RANGES = [
  '0 - 150€',
  '150 - 250€',
  '250 - 350€',
  '350 - 500€',
  '+500€',
];

export const MOCK_PROMOTER = {
  name: 'Spot Market',
  avatar:
    'https://images.squarespace-cdn.com/content/v1/5e72b55b9299231a17b1d0c5/27d0efeb-67d3-4908-ba9f-6bee7b9960f8/sheridan.png',
  totalRating: 4,
};

export const MOCK_CATEGORY_LIST = [
  'Fashion & Lifestyle',
  'Food & Beverage',
  'Technology',
];

export const MOCK_BRAND = {
  id: 1,
  name: 'Olkin Shoes',
  image: olkinLogo,
  location: 'Lisbon, Portugal',
  rating: 5,
  categories: [
    {
      id: 1,
      macro: 'Fashion & Apparel',
      icon: 'fashion_apparel',
      micro: {
        name: 'Footwear',
        icon: 'fa_footwear',
      },
    },
  ],
  foundationYear: 'November 2021',
  website: 'www.olkinshoes.com',
  longDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  history:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  facebook: 'https://www.facebook.com/olkinshoes',
  instagram: 'https://www.instagram.com/olkinshoes',
  linkdin: 'https://www.linkedin.com/company/olkinshoes',
  links: [
    { name: 'link1', url: 'www.olkinshoes.com' },
    { name: 'link2', url: 'www.olkinshoes.com' },
    { name: 'link3', url: 'www.olkinshoes.com' },
  ],
};

export const MOCK_BRANDS = [
  {
    id: 1,
    name: 'Nike',
    logo: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
  },
  {
    id: 2,
    name: 'Adidas',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Adidas_logo.png/1024px-Adidas_logo.png',
  },
  {
    id: 3,
    name: 'Puma',
    logo: 'https://www.freepnglogos.com/uploads/puma-logo-png-1.png',
  },
  {
    id: 4,
    name: 'google',
    logo: 'https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png',
  },
  {
    id: 5,
    name: 'Spotify',
    logo: 'https://www.freepnglogos.com/uploads/spotify-logo-png/spotify-icon-marilyn-scott-0.png',
  },
  {
    id: 6,
    name: 'Telegram',
    logo: 'https://www.freepnglogos.com/uploads/telegram-logo-png-0.png',
  },
  {
    id: 7,
    name: 'Starbucks',
    logo: 'https://www.freepnglogos.com/uploads/starbucks-logo-png-transparent-0.png',
  },
  {
    id: 1,
    name: 'Nike',
    logo: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
  },
  {
    id: 2,
    name: 'Adidas',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Adidas_logo.png/1024px-Adidas_logo.png',
  },
  {
    id: 3,
    name: 'Puma',
    logo: 'https://www.freepnglogos.com/uploads/puma-logo-png-1.png',
  },
  {
    id: 4,
    name: 'google',
    logo: 'https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png',
  },
  {
    id: 5,
    name: 'Spotify',
    logo: 'https://www.freepnglogos.com/uploads/spotify-logo-png/spotify-icon-marilyn-scott-0.png',
  },
  {
    id: 6,
    name: 'Telegram',
    logo: 'https://www.freepnglogos.com/uploads/telegram-logo-png-0.png',
  },
  {
    id: 7,
    name: 'Starbucks',
    logo: 'https://www.freepnglogos.com/uploads/starbucks-logo-png-transparent-0.png',
  },
];

export const BRAND_LIST = [
  {
    id: 1,
    image: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
    name: 'Nike',
    location: 'Lisbon, Portugal',
    rating: 4,
    eventsCount: 8,
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    ],
    images: ['image-url-1-1', 'image-url-1-2', 'image-url-1-3'],
  },
  {
    id: 2,
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Adidas_logo.png/1024px-Adidas_logo.png',
    name: 'Adidas',
    location: 'New York, USA',
    rating: 5,
    eventsCount: 12,
    descriptions: [
      'Quis ipsum suspendisse ultrices gravida.',
      'Risus commodo viverra maecenas accumsan lacus vel facilisis.',
    ],
    images: ['image-url-2-1', 'image-url-2-2', 'image-url-2-3'],
  },
  {
    id: 3,
    image: 'https://www.freepnglogos.com/uploads/puma-logo-png-1.png',
    name: 'Puma',
    location: 'Berlin, Germany',
    rating: 3,
    eventsCount: 6,
    descriptions: [
      'Cras ultricies ligula sed magna dictum porta.',
      'Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui.',
    ],
    images: ['image-url-3-1', 'image-url-3-2', 'image-url-3-3'],
  },
  {
    id: 4,
    image:
      'https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png',
    name: 'Google',
    location: 'San Francisco, USA',
    rating: 4,
    eventsCount: 9,
    descriptions: [
      'Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.',
      'Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.',
    ],
    images: ['image-url-4-1', 'image-url-4-2', 'image-url-4-3'],
  },
  {
    id: 5,
    image:
      'https://www.freepnglogos.com/uploads/spotify-logo-png/spotify-icon-marilyn-scott-0.png',
    name: 'Spotify',
    location: 'Amsterdam, Netherlands',
    rating: 5,
    eventsCount: 15,
    descriptions: [
      'Pellentesque in ipsum id orci porta dapibus.',
      'Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.',
    ],
    images: ['image-url-5-1', 'image-url-5-2', 'image-url-5-3'],
  },
  {
    id: 6,
    image: 'https://www.freepnglogos.com/uploads/telegram-logo-png-0.png',
    name: 'Telegram',
    location: 'Paris, France',
    rating: 4,
    eventsCount: 20,
    descriptions: [
      'Proin eget tortor risus.',
      'Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.',
    ],
    images: ['image-url-6-1', 'image-url-6-2', 'image-url-6-3'],
  },
  {
    id: 7,
    image:
      'https://www.freepnglogos.com/uploads/starbucks-logo-png-transparent-0.png',
    name: 'Starbucks',
    location: 'Copenhagen, Denmark',
    rating: 3,
    eventsCount: 10,
    descriptions: [
      'Praesent sapien massa, convallis a pellentesque nec, egestas non nisi.',
      'Nulla quis lorem ut libero malesuada feugiat.',
    ],
    images: ['image-url-7-1', 'image-url-7-2', 'image-url-7-3'],
  },
  {
    id: 8,
    image: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
    name: 'Nike',
    location: 'Vancouver, Canada',
    rating: 5,
    eventsCount: 11,
    descriptions: [
      'Vivamus suscipit tortor eget felis porttitor volutpat.',
      'Donec sollicitudin molestie malesuada.',
    ],
    images: ['image-url-8-1', 'image-url-8-2', 'image-url-8-3'],
  },
  {
    id: 9,
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Adidas_logo.png/1024px-Adidas_logo.png',
    name: 'Adidas',
    location: 'Tokyo, Japan',
    rating: 4,
    eventsCount: 14,
    descriptions: [
      'Quisque velit nisi, pretium ut lacinia in, elementum id enim.',
      'Nulla porttitor accumsan tincidunt.',
    ],
    images: ['image-url-9-1', 'image-url-9-2', 'image-url-9-3'],
  },
  {
    id: 10,
    image:
      'https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png',
    name: 'Google',
    location: 'London, UK',
    rating: 3,
    eventsCount: 8,
    descriptions: [
      'Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.',
      'Donec sollicitudin molestie malesuada.',
    ],
    images: ['image-url-10-1', 'image-url-10-2', 'image-url-10-3'],
  },
  {
    id: 11,
    image:
      'https://www.freepnglogos.com/uploads/spotify-logo-png/spotify-icon-marilyn-scott-0.png',
    name: 'Spotify',
    location: 'Milan, Italy',
    rating: 5,
    eventsCount: 7,
    descriptions: [
      'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae;',
      'In hac habitasse platea dictumst.',
    ],
    images: ['image-url-11-1', 'image-url-11-2', 'image-url-11-3'],
  },
  {
    id: 12,
    image: 'https://www.freepnglogos.com/uploads/telegram-logo-png-0.png',
    name: 'Telegram',
    location: 'Madrid, Spain',
    rating: 4,
    eventsCount: 5,
    descriptions: [
      'Proin eget tortor risus.',
      'Curabitur non nulla sit amet nisl tempus convallis quis ac lectus.',
    ],
    images: ['image-url-12-1', 'image-url-12-2', 'image-url-12-3'],
  },
  {
    id: 13,
    image:
      'https://www.freepnglogos.com/uploads/starbucks-logo-png-transparent-0.png',
    name: 'Starbucks',
    location: 'Sydney, Australia',
    rating: 4,
    eventsCount: 18,
    descriptions: [
      'Praesent sapien massa, convallis a pellentesque nec, egestas non nisi.',
      'Nulla quis lorem ut libero malesuada feugiat.',
    ],
    images: ['image-url-13-1', 'image-url-13-2', 'image-url-13-3'],
  },
  {
    id: 14,
    image: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
    name: 'Nike',
    location: 'Zurich, Switzerland',
    rating: 3,
    eventsCount: 13,
    descriptions: [
      'Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a.',
      'Vivamus suscipit tortor eget felis porttitor volutpat.',
    ],
    images: ['image-url-14-1', 'image-url-14-2', 'image-url-14-3'],
  },
  {
    id: 15,
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Adidas_logo.png/1024px-Adidas_logo.png',
    name: 'Adidas',
    location: 'Dubai, UAE',
    rating: 5,
    eventsCount: 9,
    descriptions: [
      'Cras ultricies ligula sed magna dictum porta.',
      'Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.',
    ],
    images: ['image-url-15-1', 'image-url-15-2', 'image-url-15-3'],
  },
];

export const MOCK_BRAND_INFO = {
  logo: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
  name: 'Nike',
  yearOfFoundation: 2021,
  nif: 'PT123456789',
  country: 'Portugal',
  city: 'Lisbon',
  website: 'www.nike.com',
  categories: [
    {
      id: 1,
      macro: 'Fashion & Apparel',
      icon: 'fashion_apparel',
      micro: {
        name: 'Footwear',
        icon: 'fa_footwear',
      },
    },
  ],
  keywords: ['Shoes', 'Sneakers', 'Sports', 'Footwear', 'Sports Shoes'],
  shortDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
  socialMedia: [
    { name: 'facebook', url: 'https://www.facebook.com/brand' },
    { name: 'instagram', url: 'https://www.instagram.com/brand' },
    { name: 'linkedin', url: 'https://www.linkedin.com/company/brand' },
  ],
  history:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
};
export const MOCK_PROMOTER_INFO = {
  logo: 'https://logosmarcas.net/wp-content/uploads/2020/04/Nike-Logo.png',
  name: 'The App Company',
  yearOfFoundation: 2021,
  country: 'Portugal',
  city: 'Lisbon',
  website: 'www.nike.com',
  owners: 'Manuel Simões e Rita Santos',
  socialMedia: [
    { name: 'facebook', url: 'https://www.facebook.com/brand' },
    { name: 'instagram', url: 'https://www.instagram.com/brand' },
    { name: 'linkedin', url: 'https://www.linkedin.com/company/brand' },
  ],
  history:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
};

export const MOCK_NOTIFICATIONS = [
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '10 minutes ago',
    unread: true,
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '3 hours ago',
    unread: true,
  },
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '6 hours ago',
    unread: true,
  },
  {
    status: 'rejected',
    message: 'You have been reject in EVENT_NAME.',
    timestamp: '9 hours ago',
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '1 day ago',
  },
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '10 minutes ago',
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '3 hours ago',
  },
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '6 hours ago',
  },
  {
    status: 'rejected',
    message: 'You have been reject in EVENT_NAME.',
    timestamp: '9 hours ago',
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '1 day ago',
  },
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '10 minutes ago',
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '3 hours ago',
  },
  {
    status: 'success',
    message: 'Your request for EVENT_NAME has been approved.',
    timestamp: '6 hours ago',
  },
  {
    status: 'rejected',
    message: 'You have been reject in EVENT_NAME.',
    timestamp: '9 hours ago',
  },
  {
    status: 'pending',
    message: 'Your request for EVENT_NAME is under review.',
    timestamp: '1 day ago',
  },
];

export const MOCK_USER_AMENITIES = [
  'Parking',
  'Wifi',
  'Security',
  'photography',
  'Videography',
];

export const MOCK_AMENITIES = [
  'Parking',
  'Wifi',
  'Security',
  'Restrooms',
  'Wheelchair Accessible',
  'Elevator',
  'Air Conditioning',
  'Heating',
  'Kitchen',
  'Tables',
  'Chairs',
  'Stage',
  'Sound System',
  'Lighting',
  'Projector',
  'Microphone',
  'TV Screen',
  'Photography',
  'Videography',
];

export const MOCK_SPACES = [
  {
    id: 1,
    name: 'Small',
    size: '4m²',
    description: 'Perfect for small businesses',
    price: 150,
    totalQuantity: 10,
  },
  {
    id: 2,
    name: 'Medium',
    size: '6m²',
    description: 'Perfect for medium businesses',
    price: 250,
    totalQuantity: 5,
  },
  {
    id: 3,
    name: 'Big',
    size: '8m²',
    description: 'Perfect for large businesses',
    price: 350,
    totalQuantity: 15,
  },
  {
    id: 4,
    name: 'Large',
    size: '10m²',
    description: 'Perfect for extra large businesses',
    price: 500,
    totalQuantity: 4,
  },
  {
    id: 5,
    name: 'Mega',
    size: '20m²',
    description: 'Mega space for your business',
    price: 1500,
    totalQuantity: 2,
  },
  {
    id: 1,
    name: 'Small',
    size: '4m²',
    description: 'Perfect for small businesses',
    price: 150,
  },
  {
    id: 2,
    name: 'Medium',
    size: '6m²',
    description: 'Perfect for medium businesses',
    price: 250,
  },
  {
    id: 3,
    name: 'Big',
    size: '8m²',
    description: 'Perfect for large businesses',
    price: 350,
  },
  {
    id: 4,
    name: 'Large',
    size: '10m²',
    description: 'Perfect for extra large businesses',
    price: 500,
  },
  {
    id: 5,
    name: 'Mega',
    size: '20m²',
    description: 'Mega space for your business',
    price: 1500,
  },
];

export const EVENT_LIST = [
  {
    id: 1,
    image:
      'https://images.squarespace-cdn.com/content/v1/5e72b55b9299231a17b1d0c5/27d0efeb-67d3-4908-ba9f-6bee7b9960f8/sheridan.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Campo de Ourique',
    locationCoords: { lat: 38.71834095010507, lng: -9.167003119010207 },
    date: {
      type: 'fixed',
      startDate: '2025-09-01',
      endDate: '2025-09-30',
      openHours: '14:56',
      closeHours: '20:02',
      days: [], // keep empty for fixed range
    },
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
    categories: [
      'arts_crafts',
      'fashion_apparel',
      'food_drinks',
      'tech_gadgets',
      'home_lifestyle',
    ],
    createdAt: '2024-02-14T00:00:00.000Z',
  },
  {
    id: 2,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'S-Mart Fair',
    location: 'Lisbon, Arroios',
    locationCoords: { lat: 38.76526, lng: -9.365072 },
    date: {
      type: 'fixed',
      startDate: '2025-10-12',
      endDate: '2025-10-13',
      openHours: '10:00',
      closeHours: '19:00',
      days: [],
    },
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 3,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    locationCoords: { lat: 38.803942, lng: -9.381144 },
    date: {
      type: 'fixed',
      startDate: '2025-11-24',
      endDate: '2025-11-25',
      openHours: '11:00',
      closeHours: '20:00',
      days: [],
    },
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 4,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/cheshire-county-hygiene-services.png',
    title: 'Sheridan Fair',
    location: 'Doca do Bom Sucesso, Lisboa',
    locationCoords: { lat: 38.692908, lng: -9.213155 },
    date: {
      type: 'fixed',
      startDate: '2025-12-03',
      endDate: '2025-12-04',
      openHours: '09:30',
      closeHours: '18:30',
      days: [],
    },
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 5,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/james-and-sons.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Sintra',
    locationCoords: { lat: 38.804598, lng: -9.384708 },
    date: {
      type: 'fixed',
      startDate: '2026-01-11',
      endDate: '2026-01-12',
      openHours: '10:30',
      closeHours: '19:30',
      days: [],
    },
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 6,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/baby-swim.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, 	Estrada da Pena',
    locationCoords: {
      lat: 38.787585,
      lng: -9.390614,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 7,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/crofts-accountants.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, 	Amadora',
    locationCoords: {
      lat: 38.747414,
      lng: -9.211956,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 8,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/the-web-works.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Odivelas',
    locationCoords: {
      lat: 38.789503,
      lng: -9.176891,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 9,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/auto-speed.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Vila Franca de Xira',
    locationCoords: {
      lat: 38.954107,
      lng: -9.000809,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 10,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/petes-blinds.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Torres Vedras',
    locationCoords: {
      lat: 39.08618,
      lng: -9.25714,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 12,
    image:
      'https://images.squarespace-cdn.com/content/v1/5e72b55b9299231a17b1d0c5/27d0efeb-67d3-4908-ba9f-6bee7b9960f8/sheridan.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Odivelas',
    locationCoords: {
      lat: 38.804784,
      lng: -9.187464,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 22,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Queluz',
    locationCoords: {
      lat: 38.753645,
      lng: -9.277348,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 34,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, 	Lisbon',
    locationCoords: {
      lat: 38.720923,
      lng: -9.150067,
    },
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 42,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/cheshire-county-hygiene-services.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 53,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/james-and-sons.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 64,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/baby-swim.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 74,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/crofts-accountants.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 84,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/the-web-works.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 449,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/auto-speed.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 104,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/petes-blinds.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 17,
    image:
      'https://images.squarespace-cdn.com/content/v1/5e72b55b9299231a17b1d0c5/27d0efeb-67d3-4908-ba9f-6bee7b9960f8/sheridan.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 27,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 37,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 47,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/cheshire-county-hygiene-services.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 57,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/james-and-sons.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 67,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/baby-swim.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 77,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/crofts-accountants.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 87,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/the-web-works.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 97,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/auto-speed.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 107,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/petes-blinds.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 19,
    image:
      'https://images.squarespace-cdn.com/content/v1/5e72b55b9299231a17b1d0c5/27d0efeb-67d3-4908-ba9f-6bee7b9960f8/sheridan.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 29,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 39,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/greens-food-suppliers.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 49,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/cheshire-county-hygiene-services.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 59,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/james-and-sons.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 69,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/baby-swim.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 79,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/crofts-accountants.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'JUN 25-26',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 89,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/the-web-works.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 99,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/auto-speed.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
  {
    id: 109,
    image:
      'https://pigment.github.io/fake-logos/logos/small/color/petes-blinds.png',
    title: 'Sheridan Fair',
    location: 'Lisbon, Arroios',
    dateRange: 'NOV 24-25',
    capacity: 'Almost Full',
    price: 450,
    rating: 4,
    description:
      'The Sheridan Fair is a two-day event that brings together the best of the best in the world of design and illustration. With a focus on the creative process, the event aims to inspire and educate the next generation of artists and designers.',
  },
];
